import React from 'react'
import PropTypes from 'prop-types'
import {Stack, Text, Box, useStyleConfig, Image} from '@chakra-ui/react'

const Benefit = ({description, title, url, alt}) => {
    const styles = useStyleConfig('PreFooter')

    return (
        <Stack {...styles.benefitBarStack} data-testid="benefit-bar-stack">
            <Image src={url} alt={alt} {...styles.benefitBarIcons} />

            <Box {...styles.benefitBarBox} data-testid="benefit-bar-box">
                <Text {...styles.benefitBarHeader} data-testid="benefit-bar-header">
                    {title}
                </Text>
                <Text {...styles.benefitBarText} data-testid="benefit-bar-description">
                    {description}
                </Text>
            </Box>
        </Stack>
    )
}

Benefit.propTypes = {
    description: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    alt: PropTypes.string,
}

export default Benefit
